import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import { HomeOutlined } from "@mui/icons-material";
import { Box, Button, Grid } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi } from 'api/general';
import DshReviewVoteTitle from "app/components/Box/DshReviewVoteTitle";
import AddUpdateReviewCard from 'app/components/Card/AddUpdateReviewCard';
import AddUpdateSuggestionCard from "app/components/Card/AddUpdateSuggestionCard";
import ReviewStatusCard from 'app/components/Card/ReviewStatusCard';
import LoadingPopUp from "app/components/LoadingPopup";
import VisiblePageRow from "app/components/VisiblePageRow";
import { sortByProperty } from 'app/utils/appHelpers';
import { DECISION, DECISION_FILE, REVIEWS, SUGGESTION } from 'app/utils/constants/customConstant';
import { redColor } from 'app/themes/main/default';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentMeeting, setCurrentMeetingUsers } from "stores/meeting";
import { useTemplateFontSettings } from "styles/templateFontSettings";
import Swal from 'sweetalert2';
import DashboardPageToolBar from './DashboardPageToolBar';

const ReviewPage = () => {

    const navigate = useNavigate();
    const { authUser } = useSelector(state => state.auth);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [loading, setLoading] = useState(false);
    const [decisionsOfTheMeeting, setDecisionsOfTheMeeting] = useState(null);
    const [reviewsOfTheMeeting, setReviewsOfTheMeeting] = useState([]);
    const [decisionFiles, setDecisionFiles] = useState([]);
    const [suggestionData, setSuggestionData] = useState(null);
    const userList = useSelector(state => state.user.data || []);
    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar(); // sol menu click
    const [filteredDecisions, setFilteredDecisions] = useState(null);
    const [highlightQuery, setHighlightQuery] = useState('');
    const dispatch = useDispatch();
    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);
            try {
                const [res, res2, resFiles] = await Promise.all([
                    getObjectListByPropertyApi(DECISION, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(REVIEWS, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(DECISION_FILE, "meetingId", currentMeeting.id)
                ]);
                const sorted = sortByProperty(res.data, "decisionNo");
                setDecisionsOfTheMeeting(sorted);
                setFilteredDecisions(sorted);
                setDecisionFiles(resFiles.data || []);

                let reviewData = res2.data;
                reviewData.forEach((element) => {
                    const user = userList.find((item) => item.id === element.userId);
                    element.user = user;
                });

                setReviewsOfTheMeeting(res2.data)
            } catch (error) {
                console.error("Hata:", error);
            } finally {
                setLoading(false);
            }
        };
        getAPI();
    }, []);

    useEffect(() => {
        const getSuggestions = async () => {
            try {
                const res = await getObjectListByPropertyApi(SUGGESTION, "meetingId", currentMeeting.id);
                setSuggestionData(res.data);
            } catch (error) {
                console.error(error);
            }
        };
        if (filteredDecisions !== null) {
            getSuggestions();
        }
    }, [filteredDecisions, currentMeeting.id]);

    const [reviewInputStatus, setReviewInputStatus] = useState(false);
    const [suggestionInputStatus, setSuggestionInputStatus] = useState(false);

    const handleDelete = async (item) => {
        const apiType = item.decisionId ? REVIEWS : SUGGESTION;
        const result = await deleteObjectApi(apiType, item.id);
        if (result.status) {
            if (item.decisionId) {
                const filteredList = reviewsOfTheMeeting.filter(x => x.id !== item.id);
                setReviewsOfTheMeeting(filteredList);
            } else {
                const filteredList = suggestionData.filter(x => x.id !== item.id);
                setSuggestionData(filteredList);
            }
            setReviewInputStatus(true);
            return result;
        } else {
            return null;
        }
    };

    const addAfterTable = (item) => {
        if (item.decisionId) { // review ise
            let tmp = [...reviewsOfTheMeeting];
            tmp.unshift(item);
            setReviewsOfTheMeeting(tmp);
            setReviewInputStatus(true);
        } else { // suggestion ise
            let tmp = suggestionData ? [...suggestionData] : [];
            tmp.unshift(item);
            setSuggestionData(tmp);
            setSuggestionInputStatus(true);
        }

    }

    const updateAfterTable = (item) => {
        if (item.decisionId) { // review ise
            let tmp = [...reviewsOfTheMeeting];
            const index = tmp.findIndex(x => x.id === item.id);
            index !== -1
                ? tmp[index] = item
                : tmp.push({ ...item, id: Number(tmp[tmp.length - 1].id) + 1 });
            setReviewsOfTheMeeting(tmp);
            setReviewInputStatus(true);
        } else { // suggestion ise
            let tmp = suggestionData ? [...suggestionData] : [];
            const index = tmp.findIndex(x => x.id === item.id);
            if (index !== -1) {
                tmp[index] = item;
            } else {
                tmp.push({ ...item, id: tmp.length > 0 ? Number(tmp[tmp.length - 1].id) + 1 : 1 });
            }
            setSuggestionData(tmp);
            setSuggestionInputStatus(true);
        }
    }

    const handleHomeClick = () => {
        const unreviewedDecisions = decisionsOfTheMeeting.filter(item =>
            !reviewsOfTheMeeting.some(review =>
                review.userId === authUser.id && review.decisionId === item.id
            )
        );

        unreviewedDecisions.length > 0 ?
            Swal.fire({
                html: `
                 <h4>Aşağıdaki gündem(ler)i değerlndirmediniz!</h4>
                <ul style="list-style-type: none; padding: 0; max-height: 300px; overflow-y: auto; font-size: 13px;">
                    ${unreviewedDecisions.map(decision => `
                        <li style="margin-bottom: 5px;">
                            Gündem Maddesi: <span style="color: ${redColor}">${decision.decisionNo}</span>
                        </li>
                    `).join("")}
                </ul>
                <p>Ana Sayfaya dönmek istediğinizden emin misiniz?</p>
            `,
                customClass: {
                    container: 'swal-container-custom'
                },
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {

                    dispatch(setCurrentMeetingUsers([]))
                    dispatch(setCurrentMeeting({}))

                    navigate("/")
                    setSidebarOptions({ open: true })
                }
            })

            :

            Swal.fire({
                position: 'center',
                icon: 'success',
                text: "Tüm gündemleri değerlendirdiniz",
                showConfirmButton: false,
                timer: 2500
            }).then(async () => {
                navigate("/")
                setSidebarOptions({ open: true })
            })

    }

    
    const adminUser = userList.find(item => item.id === currentMeeting.adminUserId);
    return (
        <React.Fragment>

            <LoadingPopUp open={loading} />

            {!loading &&
                <>

                    <Box
                        sx={{
                            position: "sticky",
                            top: "75px",
                            zIndex: 1100,
                            backgroundColor: "#fff",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            p: 1,
                            borderRadius: "20px",
                            maxHeight: "80px",
                            marginBottom: 1,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                            }}
                        >
                            <DshReviewVoteTitle
                                currentMeeting={currentMeeting}
                                adminUser={adminUser}
                            />

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                }}
                            >
                                <DashboardPageToolBar
                                    data2={decisionsOfTheMeeting}
                                    setData={setFilteredDecisions}
                                    setHighlightQuery={setHighlightQuery}
                                />
                                <Button onClick={() => handleHomeClick()} startIcon={<HomeOutlined />} sx={{ whiteSpace: 'nowrap' }}>
                                    Ana Sayfa
                                </Button>
                            </Box>
                        </Box>
                    </Box>

                    {

                        filteredDecisions !== null &&
                        filteredDecisions.map((decision) => {
                            const reviewOfTheUser = reviewsOfTheMeeting.find(
                                (item) =>
                                    item.decisionId === decision.id && item.userId === authUser.id
                            );

                            let filteredList = reviewsOfTheMeeting.filter(
                                (item) => item.decisionId === decision.id
                            );

                            return (
                                <VisiblePageRow key={decision.id}>
                                <Grid container spacing={1} sx={{ marginBottom: 1 }}>
                                    <Grid item xs={12} md={6} lg={8}>
                                        <AddUpdateReviewCard
                                            reviewOfTheUser={reviewOfTheUser}
                                            setReviewInputStatus={setReviewInputStatus}
                                            handleDelete={handleDelete}
                                            decision={decision}
                                            index={decision.id}
                                            addAfterTable={addAfterTable}
                                            updateAfterTable={updateAfterTable}
                                            highlightQuery={highlightQuery}
                                            decisionFiles={decisionFiles}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} lg={4}>
                                        <ReviewStatusCard
                                            title="Değerlendirme Durumu"
                                            setReviewInputStatus={setReviewInputStatus}
                                            reviewsOfTheMeeting={filteredList}
                                        />
                                    </Grid>
                                </Grid>
                                </VisiblePageRow>
                            );
                        })

                    }
                    {filteredDecisions !== null && suggestionData && (
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={6} lg={8}>
                                <AddUpdateSuggestionCard
                                    suggestionOfTheUser={suggestionData.find(item => item.userId === authUser.id)}
                                    setSuggestionInputStatus={setSuggestionInputStatus}
                                    handleDelete={handleDelete}
                                    addAfterTable={addAfterTable}
                                    updateAfterTable={updateAfterTable}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <ReviewStatusCard
                                    title="Öneri Durumu"
                                    setReviewInputStatus={setSuggestionInputStatus}
                                    reviewsOfTheMeeting={suggestionData}
                                />
                            </Grid>
                        </Grid>
                    )}
                </>
            }
        </React.Fragment>
    );
};

export default ReviewPage;
